// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1OzaP","top":"styles_top__1X98t","left":"styles_left__3ZlXM","description":"styles_description__nUEhO"};